import React, { useState, useEffect } from 'react';
import Sidebar_Progress from "../../../layouts/Operational_Sidebar_Progress.component";
import { API_URL } from "../../../../constant/API_Settings";
import swal from "sweetalert";
import ManagerLoginHeader from '../../Manager/ManagerLoginHeader.component';
import Loader from "../../../Loader/Loader";
import InvoiceSettingsFormFields from '../../shared/InvoiceSettingsFormFields';
import {
  DEFAULT_INVOICE_SETTINGS,
  applyInvoiceFieldUpdates,
  mapInvoiceSettingsFromApi,
  syncInvoiceGstFields,
  validateInvoiceSettings,
} from '../../../../utils/invoiceSettingsForm';

const InvoiceSettingsConfig = (props) => {
  const [inputValues, setInputValues] = useState(DEFAULT_INVOICE_SETTINGS);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInvoiceSettings();
  }, []);

  const loadInvoiceSettings = () => {
    setLoading(true);

    fetch(`${API_URL}/invoice-settings/show`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true && data.data) {
          setInputValues(mapInvoiceSettingsFromApi(data.data));
          setErrors({});
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleFieldChange = (nameOrPatch, value) => {
    setInputValues((prev) => applyInvoiceFieldUpdates(prev, nameOrPatch, value));
    setErrors((prev) => {
      if (nameOrPatch && typeof nameOrPatch === 'object' && !Array.isArray(nameOrPatch)) {
        const next = { ...prev };
        Object.keys(nameOrPatch).forEach((key) => {
          next[key] = null;
        });
        return next;
      }
      return { ...prev, [nameOrPatch]: null };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const synced = syncInvoiceGstFields(inputValues);
    setInputValues(synced);
    const validationErrors = validateInvoiceSettings(synced);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    fetch(`${API_URL}/invoice-settings/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
      body: JSON.stringify(synced)
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          swal("", "Invoice settings saved successfully", "success");
          loadInvoiceSettings();
        } else {
          const message = data.message || (data.errors && Object.values(data.errors).flat().join(', ')) || "Save failed";
          swal("", message, "warning");
        }
      })
      .catch(() => swal("", "Server error", "warning"));
  };

  return (
    <div className="main-container page-wrap">
      <div className="d-md-flex">
        <Sidebar_Progress props={props} progress={22} />
        <div className="content-area">
          <ManagerLoginHeader props={props} page_title="Invoice Details" />
          <div className="container pb-3">
            <div className="row mt-md-5 mt-3 justify-content-center form-container">
              <div className="form-wrap col-md-9">
                <h3 className="table-title mb-4">Invoice Details</h3>
                <p className="text-muted small mb-4">
                  Configure pump address, contact details, and GST settings for printed non-fuel invoices.
                </p>

                {loading ? (
                  <Loader />
                ) : (
                  <form onSubmit={handleSubmit}>
                    <InvoiceSettingsFormFields
                      values={inputValues}
                      errors={errors}
                      onChange={handleFieldChange}
                    />
                    <button type="submit" className="btn btn-primary">
                      Save / Update
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSettingsConfig;
